import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Form from 'components/Form';
import AccordionController from 'components/AccordionController';
import Section from 'components/Section';
import TextField from 'components/TextField';

import { useErrorHandler } from 'lib';
import { useCurrentUser } from 'components/CurrentUserProvider';

import { RegionEditMain_region$key } from '__generated__/RegionEditMain_region.graphql';
import { RegionEditMainMutation } from '__generated__/RegionEditMainMutation.graphql';

type FormValues = {
  name: string;
};

type Props = {
  region: RegionEditMain_region$key;
};

const RegionEditMain: FC<Props> = props => {
  const errorHandler = useErrorHandler();
  const { itemsPerPage } = useCurrentUser();

  const { id, ...initial } = useFragment(
    graphql`
      fragment RegionEditMain_region on Region {
        id
        name
      }
    `,
    props.region
  );

  const [update, updating] = useMutation<RegionEditMainMutation>(graphql`
    mutation RegionEditMainMutation(
      $input: UpdateRegionInput!
      $search: String
      $first: Int!
      $after: String
    ) {
      updateRegion(input: $input) {
        ...RegionEditTabs_region
        ...RegionSidebar_region
      }
    }
  `);

  const handleSubmit = useCallback(
    (input: FormValues) => {
      update({
        variables: {
          first: itemsPerPage,
          input: {
            id,

            ...input,
          },
        },

        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, itemsPerPage, update]
  );

  return (
    <Formik<FormValues> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={updating}>
        <AccordionController id="regionMain">
          <Section title="Apie" id="general">
            <Stack spacing={4}>
              <TextField name="name" label="Pavadinimas" />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default RegionEditMain;
